var _g, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUbication(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_497_13017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8477 17.6309V22.2708",
    stroke: "white",
    strokeWidth: 1.85597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8477 14.8475V14.8593",
    stroke: "white",
    strokeWidth: 1.85597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5586 22.2708V17.6309",
    stroke: "white",
    strokeWidth: 1.85597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2705 22.2708V19.4868C22.2705 18.9946 22.075 18.5225 21.7269 18.1745C21.3789 17.8264 20.9068 17.6309 20.4146 17.6309C19.9223 17.6309 19.4503 17.8264 19.1022 18.1745C18.7541 18.5225 18.5586 18.9946 18.5586 19.4868",
    stroke: "white",
    strokeWidth: 1.85597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_497_13017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7148 21.8806L20.179 25.4164C19.8665 25.7286 19.4428 25.904 19.0011 25.904C18.5593 25.904 18.1357 25.7286 17.8232 25.4164L14.2865 21.8806C13.3542 20.9482 12.7193 19.7603 12.4621 18.4671C12.2049 17.1739 12.3369 15.8335 12.8415 14.6154C13.3461 13.3972 14.2006 12.356 15.2969 11.6235C16.3932 10.891 17.6821 10.5 19.0007 10.5C20.3192 10.5 21.6081 10.891 22.7044 11.6235C23.8007 12.356 24.6552 13.3972 25.1598 14.6154C25.6644 15.8335 25.7965 17.1739 25.5392 18.4671C25.282 19.7603 24.6471 20.9482 23.7148 21.8806Z",
    fill: "#37994F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 19.667C20.3807 19.667 21.5 18.5477 21.5 17.167C21.5 15.7863 20.3807 14.667 19 14.667C17.6193 14.667 16.5 15.7863 16.5 17.167C16.5 18.5477 17.6193 19.667 19 19.667Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5597,
    cy: 18.5597,
    r: 17.8637,
    stroke: "#37994F",
    strokeWidth: 1.39198
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_497_13017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.2716,
    height: 22.2716,
    fill: "white",
    transform: "translate(7.42383 7.42285)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_497_13017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(9 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbication);
export default __webpack_public_path__ + "static/media/ubication.416ef7d5a4565e1cdd05dd016d033070.svg";
export { ForwardRef as ReactComponent };